module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.mini) ? _c('div', {
    staticClass: "revision"
  }, [_c('div', {
    staticClass: "revision__container revision__container--upload"
  }, _vm._l((_vm.submissions), function(submission) {
    return _c('div', {
      staticClass: "submission submission--upload"
    }, [_c('a', {
      staticClass: "submission__thumb-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showImage(submission.data.medium)
        }
      }
    }, [_c('img', {
      staticClass: "submission__thumb",
      attrs: {
        "src": submission.data.thumb
      }
    })])])
  }))]) : _c('div', [(_vm.title) ? _c('h2', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._l((_vm.revisions), function(revision) {
    return _c('div', {
      staticClass: "revision"
    }, [(_vm.showVersions && _vm.revisions.length > 1) ? _c('h4', {
      staticClass: "tag revision__title revision__title--no-container"
    }, [_vm._v(_vm._s(revision.title))]) : _vm._e(), _vm._l((revision.submissions), function(submission) {
      return _c('a', {
        staticClass: "submission__image-link",
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.showImage(submission.data.medium)
          }
        }
      }, [_c('img', {
        staticClass: "submission__image",
        attrs: {
          "src": submission.data.medium
        }
      })])
    })], 2)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d13f8b4","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/assignment/presenters/Upload.vue
// module id = UifB
// module chunks = 0 1